/** Routes every dashboard shares. Feature routes come from module manifests. */
export const ROUTES = {
  auth: '/auth',
  login: '/auth/login',
  app: '/app',
  account: '/app/account',
  settings: '/app/settings',
} as const;
